import React from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl, IntlShape } from 'react-intl';
import { AppState } from 'src/AppState';
import { FeedbackType } from 'src/easyclaim.api.client.typescript/src';

import { DetailContainer } from './common/CommonStyles';
import { InputFloatingPlaceholder } from './common/InputFloatingPlaceholder';
import { StarRating } from './common/StarRating';
import { TextArea } from './common/TextArea';

export interface FeedbackRatingProps extends AppState {
	feedbackMaxLength: number;
	feedbackType?: FeedbackType;
	className?: string;
	intl: IntlShape;
}

export class FeedbackRating extends React.Component<FeedbackRatingProps, {}> {
	ratingValue() {
		if (this.props.feedbackType === FeedbackType.Offer) {
			return this.props.easyClaimCase?.offerFeedbackRating;
		} else {
			return this.props.easyClaimCase?.feedbackRating;
		}
	}

	commentValue() {
		if (this.props.feedbackType === FeedbackType.Offer) {
			return this.props.easyClaimCase?.offerFeedbackComment;
		} else {
			return this.props.easyClaimCase?.feedbackComment;
		}
	}

	changeComment(comment: string) {
		const easyClaimCase = this.props.appService.app.state.easyClaimCase!;

		if (this.props.feedbackType === FeedbackType.Offer) {
			easyClaimCase.offerFeedbackComment = comment;
		} else {
			easyClaimCase.feedbackComment = comment;
		}
		this.props.appService.app.setState({ easyClaimCase });
	}

	changeRating(rating: number) {
		const easyClaimCase = this.props.appService.app.state.easyClaimCase!;

		if (this.props.feedbackType === FeedbackType.Offer) {
			easyClaimCase.offerFeedbackRating = rating;
		} else {
			easyClaimCase.feedbackRating = rating;
		}
		this.props.appService.app.setState({ easyClaimCase });
	}

	render() {
		const { intl } = this.props;

		return (
			<DetailContainer className={this.props.className}>
				<StarRating
					range={5}
					rating={this.ratingValue() ?? undefined}
					onChange={(rating) => this.changeRating(rating)}
				/>

				<div className="feedback-stars-description">
					<div className="feedback-stars-description-left">
						<FormattedMessage id="feedback.notSatisfied" />
					</div>
					<div className="feedback-stars-description-right">
						<FormattedMessage id="feedback.verySatisfied" />
					</div>
				</div>

				<h3 className="feedback-your-opinion">
					<FormattedMessage id="feedback.yourOpinion" />
				</h3>

				<TextArea
					className="feedback-textarea"
					maxLength={this.props.feedbackMaxLength}
					textLengthCounterClassName="feedback-text-length"
					value={this.commentValue() ?? ''}
					isValid={true}
					onChange={(e) => this.changeComment(e.target.value)}
				/>
				<InputFloatingPlaceholder
					className="feedback-input"
					type="string"
					pattern={'*'}
					placeholder={intl.formatMessage({ id: 'feedback.comment.placeholder' })}
					isValid={true}
					showInvalid={false}
					isRequired={false}
					feedbackMaxLength={this.props.feedbackMaxLength}
					value={this.commentValue() ?? ''}
					onChange={(e) => this.changeComment(e.target.value)}
				/>
			</DetailContainer>
		);
	}
}
export default injectIntl(FeedbackRating);
